import { useEffect } from "react";
import ToolkitTable from "components/Cards/Tables/ToolkitTable";

import { makeStyles } from "@material-ui/core/styles";
import componentStyles from "assets/theme/views/admin/react-bs-table";

import {
  Box,
  FormGroup,
  FormLabel,
  Grid,
  Button,
  IconButton,
  OutlinedInput,
  Tooltip,
  Card,
  CardContent,
  Switch,
  FormControlLabel,
  Typography,
} from "@material-ui/core";

import { columnTextField } from "utils/tables-utils";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck";
import componentButtonStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";

import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";

import ImagePlaceholder from "components/Image/ImagePlaceholder";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import Api from "lib/api/httpRequestHelper";
import FromToDateField from "components/_refactor/fields/from-to-date";
import { IsMobile900, IsMobile500, IsMobile } from "utils/is-mobile";

const useComponentStyles = makeStyles(componentButtonStyles);
const useTabStyles = makeStyles({
  ...componentStyles,
});

const useStylesCardDeck = makeStyles(componentStylesCardDeck);

export default function TableNovaVitrineVirtual({
  handleCreateShowcase,
  setShowcaseItemsList,
  creatingShowcase,
  setProductsList,
  setShowcaseName,
  dataTable,
  name,
  active,
  setActive,
  initialDate,
  setInitialDate,
  finalDate,
  setFinalDate,
  isExclusive,
  setIsExclusive,
  seller,
  setSeller,
  sellerList,
  setSellerList,
  searchingSeller,
  setSearchingSeller,
  idPessoaLoja,
}) {
  const classes = {
    ...useStylesCardDeck(),
    ...useTabStyles(),
    ...useComponentStyles(),
  };

  const isMobile900 = IsMobile900();
  const isMobile650 = IsMobile();
  const isMobile450 = IsMobile500();

  const itemMD = isMobile650 ? 12 : 10;
  const itemSM = isMobile650 ? 12 : isMobile900 ? 6 : 4;
  const itemXS = isMobile650 ? 12 : 2;

  const handleGetSeller = async () => {
    try {
      const { Result } = await Api.get(
        "store-saller",
        "commercialstructure",
        `?idPessoaLoja=${idPessoaLoja}`,
        true
      );

      setSeller("");
      setSellerList(Result?.ListaVendedores || []);
    } catch {
      setSellerList([]);
      setSeller("");
      console.error("Erro ao buscar vendedores");
    } finally {
      setSearchingSeller(false);
    }
  };

  const fotoProdutoItem = (_, row) => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <ImagePlaceholder
          className={classes.img}
          alt="Imagem do item do pedido"
          src={row.Foto}
          width={64}
          widthOnError={40}
          imagePreviewTitle={`Produto ${row.IdProduto}`}
        />
      </div>
    );
  };

  const columnModel = [
    {
      dataField: "Foto",
      text: "Imagem",
      headerAlign: "center",
      align: "center",
      sort: false,
      formatter: fotoProdutoItem,
      csvExport: false,
    },
    columnTextField({
      dataField: "Codigo",
      text: "Código",
      align: "center",
    }),
    columnTextField(
      {
        dataField: "Nome",
        text: "Descrição Produto",
        align: "left",
        formatter: (cell) => {
          return <p style={{ whiteSpace: "normal" }}>{cell}</p>;
        },
      },
      false
    ),
    {
      dataField: "deletar",
      text: "",
      isDummyField: true,
      headerStyle: { width: 45 },
      formatter: (cell, row) => (
        <Tooltip title="Remover Produto">
          <IconButton
            aria-label="delete"
            onClick={() => {
              setShowcaseItemsList((prevState) =>
                prevState.filter((item) => item?.Codigo !== row?.Codigo)
              );

              setProductsList((prevState) =>
                prevState?.map((item) => {
                  if (item.Codigo === row.Codigo) {
                    return {
                      ...item,
                      Disabled: false,
                    };
                  } else {
                    return item;
                  }
                })
              );
            }}
          >
            <Box
              component={DeleteIcon}
              width="1.25rem!important"
              height="1.25rem!important"
            />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  useEffect(() => {
    handleGetSeller();
  }, []);

  return (
    <Card>
      <CardContent>
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "1rem",
            flexDirection: isMobile650 ? "column" : "row",
          }}
        >
          <Grid item xs={itemSM}>
            <FormGroup>
              <FormLabel>Informe o Nome da Vitrine</FormLabel>
              <OutlinedInput
                fullWidth
                multiline
                disabled={creatingShowcase}
                type="text"
                value={name}
                onChange={(e) => {
                  setShowcaseName(e.target.value);
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.toString().slice(0, 100);
                }}
              />
            </FormGroup>
          </Grid>
          <Grid item xs={itemSM}>
            <FromToDateField
              isMobile900={isMobile450}
              label={"Vigência"}
              searching={creatingShowcase}
              initialDate={initialDate}
              finalDate={finalDate}
              setFinalDate={setFinalDate}
              setInitialDate={setInitialDate}
            />
          </Grid>
          <Grid item xs={itemSM}>
            <FormGroup style={{ margin: 0 }}>
              <AutoCompleteField
                label="Vendedor *"
                onChange={(newValue) =>
                  setSeller(newValue !== "all" ? newValue : "")
                }
                loading={searchingSeller}
                value={seller}
                options={sellerList}
                disabled={
                  searchingSeller ||
                  sellerList?.length === 0 ||
                  creatingShowcase
                }
                optionIdKey="IdLojaVendedor"
              />
            </FormGroup>
          </Grid>
          <Grid item xs={itemXS} style={{ display: "flex" }}>
            <FormControlLabel
              control={
                <Switch
                  checked={active}
                  onChange={(e) => setActive(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2" style={{ marginLeft: 8 }}>
                  {!active ? "Inativa" : "Ativa"}
                </Typography>
              }
              style={{ margin: 0 }}
            />
          </Grid>
          <Grid item xs={itemMD}>
            <FormControlLabel
              control={
                <Switch
                  checked={isExclusive}
                  onChange={(e) => setIsExclusive(e.target.checked)}
                />
              }
              label={
                <Typography variant="body2" style={{ marginLeft: 8 }}>
                  Vitrine Privada
                  <Tooltip
                    title="Vitrine personalizada para um cliente específico"
                    arrow
                  >
                    <IconButton style={{ padding: "0.5rem", color: "#994E53" }}>
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </Typography>
              }
              style={{ margin: 0 }}
            />
          </Grid>
        </Grid>

        <ToolkitTable
          searched={Boolean(dataTable)}
          keyField="Codigo"
          dataTable={dataTable}
          columnModel={columnModel}
          notFoundTitle=" É necessário selecionar produtos para criação da Vitrine Virtual."
          notFoundSubtitle=""
          pagination={{
            options: [25, 50, 100],
            defaultOption: 25,
          }}
        />

        <Grid
          item
          xs={12}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Button
            onClick={() => {
              setShowcaseItemsList([]);
              setProductsList([]);
            }}
            color="default"
            disabled={creatingShowcase}
          >
            Cancelar
          </Button>
          <Button
            style={{
              width: isMobile650 ? "100%" : "20vw",
              marginTop: isMobile650 ? "1rem" : 0,
            }}
            variant="contained"
            onClick={() => handleCreateShowcase()}
            disabled={
              name === "" ||
              creatingShowcase ||
              initialDate === "" ||
              finalDate === "" ||
              dataTable?.length === 0 ||
              !seller
            }
            fullWidth
          >
            <Box component={AddIcon} /> Criar
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
}
